import Glide from "@glidejs/glide";

const initialiseSliders = () => {
	document.querySelectorAll(".logo-row__glide").forEach((slider) => {
		if (!slider.getAttribute("data-initialized")) {
			const autoplayValue = slider.getAttribute("data-autoplay") === "true" ? 3000 : false;

			new Glide(slider, {
				type: "carousel",
				startAt: 0,
				perView: 5,
				focusAt: "center",
				peek: 150,
				gap: 24,
				autoplay: autoplayValue,
				breakpoints: {
					2200: {
						perView: 6,
						peek: 75,
					},
					2000: {
						perView: 4,
						peek: 150,
					},
					1440: {
						perView: 4,
						peek: 75,
					},
					1280: {
						perView: 3,
						peek: 120,
					},
					1200: {
						perView: 3,
						peek: 75,
					},
					1024: {
						perView: 3,
						peek: 25,
					},
					991: {
						perView: 2,
						peek: 75,
					},
					768: {
						perView: 2,
						peek: 10,
					},
					620: {
						perView: 1,
						peek: 130,
					},
					600: {
						perView: 1,
						peek: 125,
					},
					550: {
						perView: 1,
						peek: 120,
					},
					520: {
						perView: 1,
						peek: 75,
					},
					475: {
						perView: 1,
						peek: 60,
					},
					425: {
						perView: 1,
						peek: 50,
					},
				},
			}).mount();
			slider.setAttribute("data-initialized", "true");
		}
	});
};

const onDocumentReady = (callback) => {
	document.readyState !== "loading" ? callback() : document.addEventListener("DOMContentLoaded", callback);
};

onDocumentReady(initialiseSliders);
